var React = require('react');

function ErrorInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"alert/warning_amber_24px"},React.createElement("path",{"id":"icon/outlined/alert/warning_amber_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M1.5 32.25L18 3.75L34.5 32.25H1.5ZM29.2949 29.25L17.9999 9.735L6.70491 29.25H29.2949ZM19.5 24.75H16.5V27.75H19.5V24.75ZM16.5 15.75H19.5V21.75H16.5V15.75Z","fill":"#FF5C5C"})));
}

ErrorInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = ErrorInline;

ErrorInline.default = ErrorInline;
